import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getKitchenPrinters() {
    return axiosIns.get('/admin/kitchen_printers')
  },

  createKitchenPrinter({
    name, ipAddress, position, sdpEnabled, sdpDeviceId,
  }) {
    const params = snakecaseKeys({
      kitchenPrinter: {
        name, ipAddress, position, sdpEnabled, sdpDeviceId,
      },
    })

    return axiosIns.post('/admin/kitchen_printers', params)
  },

  updateKitchenPrinter({
    id, name, ipAddress, position, sdpEnabled, sdpDeviceId,
  }) {
    const params = snakecaseKeys({
      kitchenPrinter: {
        name, ipAddress, position, sdpEnabled, sdpDeviceId,
      },
    })

    return axiosIns.put(`/admin/kitchen_printers/${id}`, params)
  },

  deleteKitchenPrinter(id) {
    return axiosIns.delete(`/admin/kitchen_printers/${id}`)
  },

  updateRoutings(routings) {
    const params = snakecaseKeys({ routings })

    return axiosIns.put('/admin/kitchen_printers/update_routings', params)
  },

  // SDP認証情報（sdp_polling_id / sdp_password）をプリンタ単位で再発行する
  issueSdpCredentials(id) {
    return axiosIns.post(`/admin/kitchen_printers/${id}/issue_sdp_credentials`)
  },
}
